
import { Component, Input, Optional, Self, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-text-area',
  imports: [
    MatInputModule,
    ReactiveFormsModule
],
  templateUrl: './text-area.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './text-area.component.scss'
})
export class TextAreaComponent {

  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() control: UntypedFormControl = new UntypedFormControl('');
  @Input() type: string = '';

  value: string = '';
  dateValue: Date | undefined;
  disabled = false;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  // Funções do ControlValueAccessor
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
  onDateChange(dateValue: Date | undefined) {
    this.dateValue = dateValue;
    this.onChange(dateValue);
    this.onTouched();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateValue(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.onChange(inputValue);
    this.onTouched();
  }

  handleBlur() {
    this.onTouched();
  }

  get errors() {
    return this.ngControl?.errors || null;
  }

  get invalid() {
    return !!this.errors && (this.ngControl?.touched || this.ngControl?.dirty);
  }

}
